"use strict";

class grQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {
      bubbles: true
    });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.input.addEventListener('input', this.onInput.bind(this));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onButtonClick.bind(this)));
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange(event) {
    this.validateQtyRules();
  }
  onInput(event) {
    this.input.value = this.input.value.replace(/[^0-9]/g, '');
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = parseInt(this.input.value) || 0;
    if (event.target.name === 'plus') {
      this.input.value = previousValue + 1;
    } else if (event.target.name === 'minus' && previousValue > 0) {
      this.input.value = previousValue - 1;
    }
    if (previousValue !== parseInt(this.input.value)) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
  validateQtyRules() {
    const value = parseInt(this.input.value) || 0;
    // At exactly 1 the minus segment shows a trash bin (CSS swaps the glyphs).
    this.classList.toggle('is-single', value === 1);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".gr-quantity__button--minus");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".gr-quantity__button--plus");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}
customElements.define('gr-quantity-selector', grQuantityInput);